import script from "./ServerInventoryTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ServerInventoryTab.vue?vue&type=script&setup=true&lang=js"

import "./ServerInventoryTab.vue?vue&type=style&index=0&id=e6701eaa&lang=scss"

const __exports__ = script;

export default __exports__